import { Ref, useImperativeHandle } from 'react';

import {
  CommonEmployeeProposalFormHandle,
  EmployeeProposalDecision,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common/types';

type PropsType = {
  ref: Ref<CommonEmployeeProposalFormHandle> | undefined;
  handleFormSubmit: (decision?: EmployeeProposalDecision) => () => void;
};
export const useProposalFormImperativeHandle = (props: PropsType) => {
  const { ref, handleFormSubmit } = props;
  useImperativeHandle(
    ref,
    () => {
      return {
        handleSubmit: (decision?: EmployeeProposalDecision) => {
          handleFormSubmit(decision)();
        },
      };
    },
    [handleFormSubmit],
  );
};
